module.exports = angular.module(__filename, [])
.service('amDeviceDetector', ["deviceDetector", function(deviceDetector) {
  this.isSupportedDevice = function() {
    return deviceDetector.browser == 'chrome' && deviceDetector.isDesktop();
  }
}]);
